import { isCreated } from '../utils/model';
import { BasicFieldReference } from './BasicField';
import Comment from './Comment';
import Settings from './Settings';
import UploadedFile from './UploadedFile';

/**
 * Represents a single contact.
 */
export default class Contact {
  readonly id: string;
  readonly key = Math.random().toString(24);
  readonly tagIds: string[] = [];
  readonly userId: string;
  readonly date: Date;
  readonly serialId: number;
  readonly fields: BasicFieldReference[] = [];
  readonly comments: Comment[] = [];
  readonly files: UploadedFile[] = [];
  readonly importDate?: Date;
  readonly dialGroupIds: string[] = [];
  private readonly fieldValues: { [fieldId: string]: string } = {};

  constructor(deriveFrom?: Partial<Contact>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.date) {
      this.date = new Date(this.date);
    }

    if (this.importDate) {
      this.importDate = new Date(this.importDate);
    }

    if (this.comments) {
      this.comments = this.comments.map(comment => new Comment(comment));
    }

    this.fieldValues = this.fields.reduce((values, reference) => ({ ...values, [reference.fieldId]: reference.value }), {});
  }

  get isCreated() {
    return isCreated(this.id);
  }

  /**
   * @returns Whether at least one of this contact's tags locks this contact.
   */
  isLocked(settings: Settings) {
    return settings.contactTags.find(tag => tag.isLocking && this.tagIds.includes(tag.id)) != null;
  }

  /**
   * @param fieldId Order field ID.
   * @returns A field value given a field ID.
   */
  getFieldValue(fieldId: string) {
    return this.fieldValues[fieldId];
  }
}